/* eslint-disable no-unused-vars */
import { Button, CardActions, CardContent, Grid } from "@mui/material";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";

import Card from "../../components/Card/Card";
import PSelect from "../../components/pos/PSelect";
import PText from "../../components/pos/PText";
import db from "../../db/db";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import PSnakbar from "../../components/pos/PSnakbar";
import PDatePicker from "../../components/pos/PDatePicker";
import { propsToClassKey } from "@mui/styles";

const theme = createTheme({
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '[class*="MuiOutlinedInput-root"] ': {
            padding: 0,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          marginLeft: 5,
        },
        input: {
          padding: 6,
          marginLeft: 2,
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          paddingTop: 5,
          paddingBottom: 5,
          paddingRight: 15,
          "&:last-child": { paddingBottom: 5 },
        },
      },
    },
  },
});

export default function ServiceDetailsPanel(props) {
  const { t } = useTranslation();
  const translate = t;

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Card>
          <CardContent>
            <Grid container>
              <Grid item xs={2} style={{ paddingTop: 12 }}>
                {"SR #"}
              </Grid>
              <Grid item xs={4} style={{ paddingTop: 12, paddingLeft: 5 }}>
                {props.srNumber ? props.srNumber : "NEW"}
              </Grid>
              <Grid item xs={2} style={{ paddingTop: 12, paddingLeft: 20 }}>
                {props.assigneeLabel}
              </Grid>
              <Grid item xs={4} style={{ paddingLeft: 10, paddingTop: 5 }}>
                <PSelect
                  options={props.userOptions}
                  value={props.srAssignee}
                  onChange={(event, newValue) => {
                    props.setSrAssignee(newValue);
                  }}
                >
                  Select
                </PSelect>
              </Grid>
              <Grid item xs={2} style={{ paddingTop: 12 }}>
                Status
              </Grid>
              <Grid item xs={4} style={{ paddingTop: 5 }}>
                <PSelect
                  options={props.statusOptions}
                  value={props.srStatus}
                  onChange={(event, newValue) => {
                    props.setSrStatus(newValue);
                  }}
                />
              </Grid>
              <Grid item xs={2} style={{ paddingTop: 12, paddingLeft: 20 }}>
                Delivery Date
              </Grid>
              <Grid item xs={4} style={{ paddingLeft: 10, paddingTop: 5 }}>
                <PDatePicker
                  value={props.srEta}
                  type="date"
                  onChange={(e) => props.setSrEta(e.$d.toISOString())}
                ></PDatePicker>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    </ThemeProvider>
  );
}
